import * as GQL from "src/types/graphql";

export const getRuleType = (
  questionType: GQL.question_type_enum | undefined
) => {
  if (!questionType) return undefined;
  switch (questionType) {
    case GQL.question_type_enum.Address: {
      return GQL.form_engine_rule_type_enum.GEOGRAPHIC_PREFERENCE_TAG;
    }
    case GQL.question_type_enum.Grades:
    case GQL.question_type_enum.SingleSelect:
    case GQL.question_type_enum.MultiSelect:
      return GQL.form_engine_rule_type_enum.QUESTION_TAG;
    default:
      return undefined;
  }
};
